export const CheckboxTypes = Object.freeze({
    Solid: 'SOLID',
    Outline: 'OUTLINE'
});

export const CheckboxVersions = Object.freeze({
    v1: 'V1',
    v2: 'V2'
});
